import { mapGetters} from 'vuex'
import { urlWithParams } from '../helpers/url-params'

export const actionUrlWithParamsMixin = {
  computed: {
    ...mapGetters(['urlKeysIncludedInItemPageUrls']),

    actionUrlWithParams() {
      const params = new URLSearchParams(window.location.search)
      const urlParamsToInclude = {}
      this.urlKeysIncludedInItemPageUrls.forEach(key => {
        if (params.get(key)) {
          urlParamsToInclude[key] = params.get(key)
        }
      })
      return urlWithParams(this.actionUrl, urlParamsToInclude)
    }
  }
}
